var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDigits(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52_112)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 1C8.03484 1.22222 7.61847 1.53469 7.27513 1.91923C6.93179 2.30378 6.66831 2.75273 6.5 3.24C6.7305 3.43535 6.89471 3.69739 6.97 3.99C7.48 3.93 7.97 3.89 8.5 3.88V1Z",
    fill: "#36A9E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 13.47C6.58 15.31 7.47 16.62 8.5 16.96V14.78C8.25933 14.6956 8.04269 14.5542 7.86855 14.3678C7.69441 14.1815 7.56795 13.9558 7.5 13.71C6.99333 13.6566 6.49333 13.5766 6 13.47Z",
    fill: "#36A9E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 4C5.36739 4 5.24022 4.05268 5.14645 4.14645C5.05269 4.24021 5 4.36739 5 4.5C5.00256 4.63181 5.05606 4.7575 5.14928 4.85072C5.2425 4.94394 5.36819 4.99744 5.5 5C5.63261 5 5.75979 4.94732 5.85356 4.85355C5.94733 4.75979 6 4.63261 6 4.5C6 4.36739 5.94733 4.24021 5.85356 4.14645C5.75979 4.05268 5.63261 4 5.5 4Z",
    fill: "#36A9E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 5C7.94024 5.01364 7.38217 5.06712 6.83 5.16C6.73169 5.39253 6.57841 5.59773 6.38333 5.75797C6.18825 5.91822 5.9572 6.02872 5.71001 6.08C5.58829 6.87799 5.51813 7.68299 5.5 8.49H8.5V5Z",
    fill: "#36A9E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 9.46997C5.52977 10.3813 5.6402 11.2882 5.83 12.18C6.41956 12.3163 7.01755 12.4132 7.62 12.47C7.69691 12.271 7.8151 12.0906 7.96678 11.9407C8.11846 11.7907 8.30019 11.6746 8.5 11.6V9.46997H5.5Z",
    fill: "#36A9E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 8.46997C13.3674 8.46997 13.2402 8.52265 13.1465 8.61642C13.0527 8.71019 13 8.83736 13 8.96997C13 9.10258 13.0527 9.22976 13.1465 9.32352C13.2402 9.41729 13.3674 9.46997 13.5 9.46997C13.6326 9.46997 13.7598 9.41729 13.8536 9.32352C13.9473 9.22976 14 9.10258 14 8.96997C14 8.83736 13.9473 8.71019 13.8536 8.61642C13.7598 8.52265 13.6326 8.46997 13.5 8.46997Z",
    fill: "#36A9E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C11.61 0.32 13.08 2.09 13.79 4.68C16.36 5.38 18.15 6.85 18.47 8.46C18.3119 6.26687 17.3685 4.20423 15.8128 2.65034C14.2571 1.09646 12.1933 0.155493 10 0Z",
    fill: "#36A9E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 6C14.0867 6.46 14.1567 6.94 14.21 7.44C14.45 7.52174 14.6702 7.653 14.8562 7.82526C15.0423 7.99753 15.1901 8.20697 15.29 8.44H17.5C17.16 7.52 15.85 6.55 14 6Z",
    fill: "#36A9E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.29 9.46997C15.2017 9.71009 15.0579 9.92589 14.8701 10.0997C14.6824 10.2735 14.4562 10.4004 14.21 10.47C14.21 11 14.09 11.47 14 11.99C15.85 11.41 17.15 10.51 17.5 9.49997L15.29 9.46997Z",
    fill: "#36A9E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.46997C0.135035 11.6801 1.07392 13.7646 2.63966 15.3303C4.2054 16.896 6.28983 17.8349 8.5 17.97C6.87 17.64 5.5 15.82 4.78 13.22C2.16 12.47 0.359999 11.12 0.0299988 9.46997H0Z",
    fill: "#36A9E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.36 6C3.73444 6.18336 3.15545 6.49871 2.66209 6.92479C2.16873 7.35087 1.77246 7.87779 1.5 8.47H4.3C4.32026 7.66681 4.38704 6.86547 4.5 6.07L4.36 6Z",
    fill: "#36A9E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 9.46997C1.78431 10.0814 2.20095 10.6219 2.71979 11.0526C3.23863 11.4832 3.84669 11.7931 4.5 11.96C4.36842 11.136 4.29159 10.3041 4.27 9.46997H1.5Z",
    fill: "#36A9E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 0C6.29364 0.141097 4.21411 1.0806 2.64987 2.64299C1.08564 4.20539 0.143694 6.28381 0 8.49C0.27 7.14 1.61001 5.82 3.71001 5.05C3.65548 4.81855 3.65423 4.57774 3.70636 4.34574C3.75849 4.11374 3.86265 3.8966 4.01096 3.71074C4.15927 3.52487 4.34786 3.37511 4.5625 3.27278C4.77714 3.17045 5.01222 3.11821 5.25 3.12H5.36C6.15 1.36 7.26 0.260002 8.5 0.0100021V0Z",
    fill: "#36A9E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.47 9.47005C18.15 11.0901 16.38 12.4701 13.79 13.1901C13.08 15.8101 11.61 17.6101 10 17.9301C12.2072 17.7866 14.2869 16.845 15.8509 15.281C17.415 13.7169 18.3566 11.6373 18.5 9.43005L18.47 9.47005Z",
    fill: "#36A9E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1V4.22C10.8396 4.24396 11.6759 4.33761 12.5 4.5C11.95 2.65 10.97 1.34 10 1Z",
    fill: "#36A9E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5V8.47H12.17C12.2943 8.00217 12.5908 7.59857 13 7.34C12.9504 6.6685 12.8603 6.00061 12.73 5.34C11.8346 5.13043 10.9195 5.01646 10 5Z",
    fill: "#36A9E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 13.47C11.9838 13.5637 11.4631 13.6305 10.94 13.67C10.8794 13.9113 10.7627 14.1349 10.5993 14.3226C10.436 14.5102 10.2307 14.6567 10 14.75V16.96C10.97 16.65 11.95 15.34 12.5 13.47Z",
    fill: "#36A9E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 12.47C9.05281 12.47 8.86354 12.5477 8.72318 12.6862C8.58281 12.8247 8.50263 13.0129 8.5 13.21C8.5 13.4089 8.57901 13.5997 8.71967 13.7404C8.86032 13.881 9.05109 13.96 9.25 13.96C9.44891 13.96 9.63968 13.881 9.78033 13.7404C9.92099 13.5997 10 13.4089 10 13.21C10 13.112 9.98055 13.015 9.94273 12.9245C9.90492 12.8341 9.84952 12.7521 9.77974 12.6832C9.70996 12.6144 9.62719 12.5601 9.53625 12.5235C9.44532 12.4869 9.34802 12.4687 9.25 12.47Z",
    fill: "#36A9E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.46997V11.6C10.2008 11.6729 10.3834 11.7884 10.5353 11.9386C10.6872 12.0888 10.8048 12.27 10.88 12.47C11.502 12.4114 12.1199 12.3145 12.73 12.18C12.8605 11.58 12.9507 10.972 13 10.36C12.8078 10.2768 12.6349 10.1548 12.4921 10.0017C12.3492 9.84851 12.2396 9.66749 12.17 9.46997H10Z",
    fill: "#36A9E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52_112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.5,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigits);
export default __webpack_public_path__ + "static/media/Digits.e2acddaecf7f3019eac1efbe9ed35840.svg";
export { ForwardRef as ReactComponent };